export default __webpack_public_path__ + "static/media/ARTWEB_Background.075750d0.jpg";